<template>
  <div class="flex items-center justify-center">
    <span :class="getClasses" class="loader"></span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  const props = defineProps({
    color: {
      type: String,
      default: 'secondary'
    }
  });

  const getClasses = computed(()  => {
    let classes = '';
    classes += '!border-' + props.color;
    return classes;
  });

</script>

<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 5px dotted;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 2s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
